module.exports = __webpack_public_path__ + "static/media/preview.137b45ce.png";